import { useEffect } from "react";
import { VendingHistory } from "./VendingHistory";
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
import UtilityPageLayout from "../../component/layout/UtilityPageLayout";
import { FeatureFlagName } from "../../../../tenant/features/featureFlags";
import { useFeatureFlag } from "../../../../tenant/features/useFeatureFlag";

export const VendingPage = () => {
    const { updateLayout } = useConfigLayout();
    const vendingHistoryEnabled = useFeatureFlag(FeatureFlagName.ADMIN_VENDING_HISTORY);

    useEffect(() => {
            updateLayout({
                showCountrySelector: false,
                utility: null,
                // Nothing to export while the feature is locked.
                showExportButton: vendingHistoryEnabled,
                showBreadCrumb: false,
            });
        }, [updateLayout, vendingHistoryEnabled]);

    return (
        <>
            <UtilityPageLayout title="Vending History" feature={FeatureFlagName.ADMIN_VENDING_HISTORY}>
                <VendingHistory/>
            </UtilityPageLayout>
        </>
    );
}